import { render, staticRenderFns } from "./ptOrderInfo.vue?vue&type=template&id=5e8be1c8&scoped=true&"
import script from "./ptOrderInfo.js?vue&type=script&lang=js&"
export * from "./ptOrderInfo.js?vue&type=script&lang=js&"
import style0 from "./ptOrderInfo.css?vue&type=style&index=0&id=5e8be1c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8be1c8",
  null
  
)

export default component.exports